import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import SliderRow from './../../../reusable/Form/SliderRow';

export default class SliderExperianLevelsStability extends Component {

    constructor(props) {
        super(props);

        this.onSliderChange = this.onSliderChange.bind(this);
    }

    onSliderChange(value, riskAngleKey) {

        let changedRiskAngle = {};
        changedRiskAngle[riskAngleKey] = value;

        this.props.changeExperianSliders(changedRiskAngle);
    }

    render() {

        return (
            <div className="risk-sliders">
                <div className="risk-sliders__labels">
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.stabilityRisk.high'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.stabilityRisk.mediumHigh'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.stabilityRisk.medium'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.stabilityRisk.lowMedium'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.stabilityRisk.low'/>
                    </span>
                </div>

                <SliderRow key={'stability-risk-slider'}
                           ref={'stabilityRisk'}
                           label={'Alerts_Create_UIText_name.step1.experianSection.stabilityRisk'}
                           value={this.props.stabilityRisk}
                           onChange={this.onSliderChange}
                           onChangeData={'stabilityRisk'}
                           min={0}
                           max={4} />

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepOneComponents/CreateAlert.StepOne.SliderExperianLevelsStability.jsx